import { makeStyles, TableCell, TableRow, withStyles } from "@material-ui/core";
export const useStyles = makeStyles((theme) => ({
    eventContainer: {
        borderRadius: 12,
    },
    table: {
        minWidth: 950,
        [theme.breakpoints.down('sm')]: {
            width: 1500,
        },
    },
    partitionDiv:{
        display:"flex",
        alignItems:"center"
    },
    partitiontxt: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "22px",
        lineHeight: "28px",
        marginTop: "30px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.001em",
        color: "#091E42",
        marginBottom:"30px"
    },
    refreshIcon:{
        marginLeft:"8px"
    }
}))
export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#5B6773',
        color: '#ffffff',
        height: 52,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
        paddingLeft: 30
    },
    body: {
        fontSize: 14,
        height: 52,
        color: '#5B6773',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        paddingLeft: 30,
    },

}))(TableCell);

export const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F4F6F8',
        },
    },
}))(TableRow);